import { render, staticRenderFns } from "./PasswordForceChange.vue?vue&type=template&id=312a05d4&"
import script from "./PasswordForceChange.vue?vue&type=script&lang=js&"
export * from "./PasswordForceChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports